import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '@farris/devkit';

@Pipe({ name: 'parseStrToDate' })
export class StringToDatePipe implements PipeTransform {
    transform(value: string, exponent: string): any {
        if (DateUtil.isEmptyDateString(value) === true) {
          return null;
        }

        if (value.includes('å¹´')) {
            const strDate = value.replace('å¹´', '-').replace('æ', '-').replace('æ¥', '');
            return new Date(strDate);
        }
        return new Date(value);
    }
}
